export class SelectListItemModel {
    public id: number;
    public name: string;
}



// WEBPACK FOOTER //
// ./src/models/select.list.item.model.ts